<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show"
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter
                                    queryApi="findExecute"
                                    :entity="modelName"
                                    ref="emListFilter"
                                    $_em-custom-vuex-mixin_filter="andonUserFilter"
                                    @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdOperationUserResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table
                                with-custom-row-actions-first-column
                                custom-row-actions-text-first-column="工序执行"
                                queryApi="findExecute"
                                withCustomRowActionsFistColumn
                                checkbox-column-disabled
                                :entity="modelName"
                                edit-disable
                                ref="emTable"
                                exportDisabled
                                :inlineActionsDisabled="prop_inline !== '1'"
                                @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button
                                            type="gotoExecute"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="gotoExecute(row)">
                                        </em-button>
                                        <em-button
                                            type="edit" custom-icon="fa fa-fw fa-lg fa-print"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="print(row)">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="查看工装上挂详情"
                                            @click="gotoToolsRelatePage(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector
            ref="emModalEntitySelector"
        ></em-modal-entity-selector>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-10-04 06:46:06

import emCommonListMixin from "@/mixin/em/common/list";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "sithMesPrdOperationUserListView",
    mixins: [emCommonListMixin, emApiMixin, commonViewsUtil, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    beforeCreate() {
        this.$store.commit("sithMesPrdOperationUser/setNeedToRefresh", true);
    },
    methods: {
        gotoExecute(row) {
            this.$router.push({
                name: `SithMesPrdOperationExecute`,
                query: {
                    header: row.prdPpHeaderId,
                    operation: row.prdPpOperationId,
                }
            });
        },
        print(row) {
            let url = `${this.entityBaseUrl}print?id=${row.id}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    this.$router.push({
                        name: "sithMesInventoryItemPrint",
                        query: response.data,
                    });
                })
        },
        //跳转工装上挂页面
        gotoToolsRelatePage(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesPrdToolsRelateOperation"
                , {operationIdFilter: row.prdPpOperationId, operationSeqFilter: row.prdPpOperationSeq}
                , {operationId: row.prdPpOperationId, operationSeq: row.prdPpOperationSeq}, false, {});
        },
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName;
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
    }
};
</script>
